import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {AccountConfig} from '@app/interfaces/config/account.config';
import {AccountProductPackage} from '@app/interfaces/packages/account-product-package';
import {ConfigAPIService} from '@app/services/api/config-api.service';
import {take, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { isBrowser } from '@app/util/is-browser';

@Component({
    selector: 'app-open-product-package-offer-dialog-component',
    templateUrl: './open-product-package-offer-dialog-component.component.html',
    styleUrls: ['./open-product-package-offer-dialog-component.component.scss'],
    standalone: false
})
export class OpenProductPackageOfferDialogComponentComponent implements OnInit, OnDestroy {
  public accountConfig: AccountConfig;
  public accountProductPackage: AccountProductPackage;
  private destroy$ = new Subject<void>();
  private pollingInterval: ReturnType<typeof setInterval>;
  public linkOpened: boolean;
  protected isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private configApi: ConfigAPIService,
  ) {
    this.accountConfig = data.accountConfig;
    this.accountProductPackage = data.accountConfig.activeAccountProductPackage;
  }

  static open(dialog: MatDialog, accountConfig: AccountConfig) {
    return dialog.open(OpenProductPackageOfferDialogComponentComponent, {
      width: '600px',
            disableClose: true,
      data: {
        accountConfig,
      }
    });
  }

  ngOnInit(): void {
    this.pollingInterval = setInterval(() => {
      this.configApi.getAccountConfig(null, true).pipe(take(1), takeUntil(this.destroy$)).subscribe((config) => {
        if (config.activeAccountProductPackage.isSigned || config.activeAccountProductPackage.isRejected) {
          this.refresh();
        }
      });
    }, 15000);
  }

  public ngOnDestroy() {
    clearInterval(this.pollingInterval);
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openPaymentUrlInTab() {
    window.open(this.accountProductPackage.paymentUrl, '_blank');
    this.linkOpened = true;
  }

  public refresh() {
    this.isLoading = true;
    if(isBrowser()) {
      window.location.reload();
    }
  }
}
